let ghfMobileBreakpoint = 767;
let ghfShowBack = false;
let ghfLastWidth = 0;

document.addEventListener('DOMContentLoaded', () => {
	ghfSetBreakpoint();

	const selecteds = Array.from(document.querySelectorAll('[class*="ghf-select"]')) as Array<HTMLButtonElement>;
	const toggles = Array.from(document.querySelectorAll('[class*="ghf-toggle"]')) as Array<HTMLButtonElement>;
	ghfBindToggles(toggles);
	ghfBindSelecteds(selecteds);
	ghfBindResize(toggles, selecteds);
	ghfBindMenu();
	ghfBindCategoryButtons();
	// ghfTest();
});
function ghfBindCategoryButtons() {
	Array.from(document.querySelectorAll('.ghf-select-vehicle-category')).forEach(el => {
		el.addEventListener('keydown', function(this: HTMLElement, e: Event){
			const key = (e as KeyboardEvent).key;
			const divEl: HTMLDivElement | null | undefined = this.closest('dt')?.closest('div');

			if (key == 'ArrowUp' && divEl?.previousElementSibling) {
				e.preventDefault();
				const newEl: HTMLButtonElement | null = divEl.previousElementSibling.querySelector('.ghf-select-vehicle-category');
				newEl?.focus();
			}
			else if (key == 'ArrowDown' && divEl?.nextElementSibling) {
				e.preventDefault();
				const newEl: HTMLButtonElement | null = divEl.nextElementSibling.querySelector('.ghf-select-vehicle-category');
				newEl?.focus();
			}
		});
	});
}
// function ghfTest(){
// 	Array.from(document.querySelectorAll('*')).forEach((el: Element) => {
// 		(el as HTMLAnchorElement | HTMLButtonElement | HTMLInputElement).addEventListener('focus', function(){
// 			console.log('focus ', el, (el.textContent?.trim() || el.getAttribute('aria-label') || ''));
// 		});
// 	});
// }
function ghfSetBreakpoint() {
	const r = document.querySelector(':root') as HTMLElement;
	if (!r) return;
	var style = window.getComputedStyle(r);
	const bStr = style.getPropertyValue('--ghf-header-mobile-breakpoint');
	if (!bStr) return
	const b = parseInt(bStr);
	if (isNaN(b)) return
	ghfMobileBreakpoint = b;
}
function ghfBindMenu() {
	const els = Array.from(document.querySelectorAll('.ghf-header-menu > ul > li > *:not(:last-child)'));
	els.forEach((el) => {
		el.addEventListener('click', function(this: HTMLElement, e: Event){
			if (window.innerWidth <= ghfMobileBreakpoint && this.nextSibling) {
				const menuHeaderEl = document.querySelector('.ghf-header-menu-header');
				e.preventDefault();
				this.closest('li')?.classList.add('ghf-header-menu-open');
				menuHeaderEl?.classList.add('ghf-header-show-back');
			}
		});
	});
	const backs = Array.from(document.querySelectorAll('.ghf-header-menu-back'));
	backs.forEach(back => {
		back.addEventListener('click', function(e: Event){
			ghfResetNav();
		});
	});
	Array.from(document.querySelectorAll('.ghf-toggle-menu')).forEach(el => {
		el.addEventListener('click', function(){
			ghfResetNav();
		});
	});
	Array.from(document.querySelectorAll('.ghf-toggle-new-vehicles')).forEach(el => {
		el.addEventListener('click', function(this: HTMLElement){
			const ap = this.getAttribute('aria-pressed') == "true";
			const isNotMobile = window.innerWidth > ghfMobileBreakpoint;
			const url = this.getAttribute('data-new-vehicles-url') || '';
			if (isNotMobile && ap && url){
				(window as Window).location = url;
			}
		});
	});
	Array.from(document.querySelectorAll('.ghf-toggle-menu, .ghf-toggle-ctc')).forEach(el => {
		el.addEventListener('click', function(){
			const isPressed = el.getAttribute('aria-pressed') == "true";
			handleAggheadZIndex(isPressed);
		});
	});
}
function handleAggheadZIndex(aboveAll: boolean){
	const el = document.getElementById('agghead');
	if (!el) return;
	if (aboveAll) {
		el.style.zIndex = "99999";
	}
	else {
		el.setAttribute('style', '');
	}
}
function ghfResetNav() {
	const menuHeaderEl = document.querySelector('.ghf-header-menu-header');
	menuHeaderEl?.classList.remove('ghf-header-show-back');
	Array.from(document.querySelectorAll('.ghf-header-menu-open')).forEach(el => {
		el.classList.remove('ghf-header-menu-open');
	});
	document.querySelectorAll('.ghf-toggle-new-vehicles[aria-pressed=true]').forEach(el => {
		el.setAttribute('aria-pressed', 'false');
		const id = el.getAttribute('aria-controls') || '';
		if (!id) return;
		document.getElementById(id)?.setAttribute('aria-hidden', 'true');
	});
}
function ghfBindResize(toggles: Array<HTMLButtonElement>, selecteds: Array<HTMLButtonElement>) {
	const bodyEl = document.querySelector('body') as HTMLBodyElement;
	const resizeObserver = new ResizeObserver(() => {
		if (ghfLastWidth == window.innerWidth) return;
		ghfLastWidth = window.innerWidth;
		toggles.forEach(el => {
			setDefaultToggleControlledAriaHidden(el);
		});
		selecteds.forEach(el => {
			setDefaultSelectedControlledAriaHidden(el);
		});
		bodyEl.classList.remove('ghf-disable-scroll');
		Array.from(document.querySelectorAll('.ghf-header-menu-open')).forEach(el => {
			el.classList.remove('ghf-header-menu-open');
		});
		Array.from(document.querySelectorAll('.ghf-header-show-back')).forEach(el => {
			el.classList.remove('ghf-header-show-back');
		});
		setHeaderHeight();
	}); 
	resizeObserver.observe(bodyEl);
	setHeaderHeight();
}
function setHeaderHeight() {
	const r = document.querySelector(':root') as HTMLElement;
	const headerEl = document.querySelector('.ghf-header');
	if (!r || !headerEl) return;
	r.style.setProperty('--ghf-header-height', headerEl.clientHeight + 'px');
}
function ghfBindSelecteds(selecteds: Array<HTMLButtonElement>) {
	selecteds.forEach((element) => {
		const el = element as HTMLButtonElement;
		el.addEventListener('click', ghfHandleSelectedClick);
		setDefaultSelectedControlledAriaHidden(el);
	});
}
function setDefaultSelectedControlledAriaHidden (el: HTMLButtonElement) {
	const cid = el.getAttribute('aria-controls') || '';
	if (!cid) return;
	const cidEl = document.getElementById(cid);
	const isPressed = window.innerWidth <= ghfMobileBreakpoint ? 
		el.getAttribute('data-default-mobile-selected') == "true" : 
		el.getAttribute('data-default-desktop-selected') == "true"
	;
	el.setAttribute('aria-selected', isPressed.toString().toLowerCase());
	cidEl?.setAttribute('aria-hidden',  (!isPressed).toString().toLowerCase());
}
function ghfHandleSelectedClick(this: HTMLElement, e: Event) {
	e.preventDefault();
	const isSelected = this.getAttribute('aria-selected') == "true";
	const name = this.getAttribute('data-aria-controls-name');
	if (isSelected || !name) return;

	const allSelectedsWithName = document.querySelectorAll(`[data-aria-controls-name="${name}"]`);
	allSelectedsWithName.forEach(el => {
		const cid = el.getAttribute('aria-controls') || '';
		if (!cid) return;
		Array.from(document.querySelectorAll(`[aria-controls="${cid}"]`)).forEach(el => {
			el.setAttribute('aria-selected', "false");
		});
		document.getElementById(cid)?.setAttribute('aria-hidden', "true");
	});

	const cid = this.getAttribute('aria-controls') || '';
	if (!cid) return;
	Array.from(document.querySelectorAll(`[aria-controls="${cid}"]`)).forEach(el => {
		el.setAttribute('aria-selected', "true");
	});
	document.getElementById(cid)?.setAttribute('aria-hidden', "false");
}
function ghfBindToggles(toggles: Array<HTMLButtonElement>) {
	toggles.forEach((element) => {
		const el = element as HTMLButtonElement;
		el.addEventListener('click', ghfHandleToggleClick);
		setDefaultToggleControlledAriaHidden(el);
	});
}
function setDefaultToggleControlledAriaHidden (el: HTMLButtonElement) {
	const cid = el.getAttribute('aria-controls') || '';
	if (!cid) return;
	const cidEl = document.getElementById(cid);
	const isPressed = window.innerWidth <= ghfMobileBreakpoint ? 
		el.getAttribute('data-default-mobile-pressed') == "true" : 
		el.getAttribute('data-default-desktop-pressed') == "true"
	;
	el.setAttribute('aria-pressed', isPressed.toString().toLowerCase());
	cidEl?.setAttribute('aria-hidden', (!isPressed).toString().toLowerCase());
}
function ghfHandleToggleClick (this: HTMLElement, e: Event) {
	e.preventDefault();
	const cid = this.getAttribute('aria-controls') || '';
	if (!cid) return;
	const isPressed = this.getAttribute('aria-pressed') == "true";
	Array.from(document.querySelectorAll(`[aria-controls="${cid}"]`)).forEach(el => {
		el.setAttribute('aria-pressed', (!isPressed).toString().toLowerCase());
	});
	document.getElementById(cid)?.setAttribute('aria-hidden', (isPressed).toString().toLowerCase());
	const disableBodyScroll = this.getAttribute('data-disable-scroll') == "true";
	if (!disableBodyScroll) return;
	document.body.classList.toggle('ghf-disable-scroll', !isPressed);
}